/* eslint-disable no-use-before-define */
import React from 'react'
import { COUPON_TYPE_LABELS, showModal, arrayFrom, fmt } from '../twd'

const formatCouponType = (r) => {
    let c = r.couponTypeCode
    if (c==='B') return 'Zero'
    if (['A','C','F','K','N'].indexOf(c)>=0) return 'Fixed, Non-Zero'
    if (r.f2fFixedInd==='Y') return 'Fixed to Float, Fixed'
    if (arrayFrom(r.stepSchedule).length>1) return 'Multi-Step'
    if (['D','I','E','G'].indexOf(c)>=0) return 'Floating'
}

export default ({issue, offer}) => {
    let label = formatCouponType(issue)
        || COUPON_TYPE_LABELS[issue.couponTypeCode]
        || fmt.empty()


    if (arrayFrom(issue.stepSchedule).length>1) {
        return <button
            className="link-button"
            onClick={(e) => {
                showModal({
                    view: 'multi-step-coupon',
                    issue,
                    from: 'bond-detail',
                    source: e.target,
                })
            }}>
            {label}
        </button>
    }

    if (issue.floaterInd==='Y' && issue.f2fFixedInd==='Y') {
        return <button
            className="link-button"
            onClick={(e) => {
                showModal({
                    view: 'f2f-info',
                    issue,
                    from: 'bond-detail',
                    source: e.target,
                })
            }}>
            {label}
        </button>
    }

    if (issue.floaterInd==='Y' && ['O','R','K'].indexOf(issue.type)<0) {
        return <button
            className="link-button"
            onClick={(e) => {
                showModal({
                    view: 'ars-info',
                    issue,
                    offer,
                    from: 'bond-detail',
                    source: e.target,
                })
            }}>
            {label}
        </button>
    }

    return label
}